/* eslint-disable no-unused-vars */
import anime from 'animejs'

export default {
    init() {
        const sock = document.getElementsByClassName('sock')[0]
        const animationInfos = {
            isHover: false,
            loopCount: 0,
            currentTimeout: null,
            randomAnimation: null,
        }

        /*sock.addEventListener('mouseenter', () =>
        {
            animationInfos.isHover = true
            window.clearTimeout(animationInfos.currentTimeout)
            animationInfos.currentAnimation.pause()
            animationInfos.currentAnimation.restart()
            animationInfos.randomAnimation()
        })

        sock.addEventListener('mouseleave', () =>
        {
            animationInfos.isHover = false
            animationInfos.loopCount = 0
        })

        const activatingAnimation = () =>
        {
            if(animationInfos.loopCount < 3)
            {
                anime({
                    targets: sock,
                    rotate: [0, 360],
                    duration: 1000,
                    easing: 'easeInSine',
                    autoplay: 3,
                    begin: () =>
                    {
                        animationInfos.loopCount++
                    },
                    complete: () =>
                    {
                        if(animationInfos.loopCount > 2)
                        {
                            sock.setAttribute('href', sock.getAttribute('data-target'))
                        }
                    },
                })
            }
        }*/
        
        const rotateAnimation = () =>
        {
            return anime({
                targets: sock,
                keyframes: [
                    {rotate: -40},
                    {rotate: 40},
                    {rotate: 0},
                ],
                duration: 2000,
                easing: 'easeInOutSine',
                autoplay: true,
            })
        }
    
        const pulseAnimation = () =>
        {
            return anime({
                targets: sock,
                keyframes: [
                    {scale: 1.3},
                    {scale: 1},
                    {scale: 1.3},
                    {scale: 1},
                ],
                duration: 3000,
                easing: 'easeInOutSine',
                autoplay: true,
            })
        }
    
        const moveAnimation = () =>
        {
            return anime({
                targets: sock,
                easing: 'easeInOutSine',
                duration: 1000,
                autoplay: true,
                update: (anim) =>
                {
                  const progress = Math.round(anim.progress)
                  const angle = progress / 100 * 2 * Math.PI
                  const radius = 10
                  sock.style.transform = 'translate(' + (-((Math.cos(angle) - 1) * radius)) + 'px,' + (-Math.sin(angle) * radius) + 'px)'
                },
                complete: () =>
                {
                    sock.style.transform = ''
                },
            })
        }

        const randomAnimation = () =>
        {
            if(!animationInfos.isHover)
            {
                /*const randomVal = Math.random()
                if(randomVal < 1/3)
                {
                    animationInfos.currentAnimation = rotateAnimation()
                }
                else if(randomVal > 2/3)
                {
                    animationInfos.currentAnimation = pulseAnimation()
                }
                else
                {
                    animationInfos.currentAnimation = moveAnimation()
                }*/
                animationInfos.currentAnimation = rotateAnimation()

                animationInfos.currentTimeout = setTimeout(randomAnimation, 3000 + Math.random() * 5000);
            }
            /*else
            {
                animationInfos.activeAnimation = activatingAnimation()
                animationInfos.currentTimeout = setTimeout(randomAnimation, 1000);
            }*/
        }
        animationInfos.randomAnimation = randomAnimation

        randomAnimation()
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateStudio.js